import { lazy } from "react";
const Signup = lazy(() => import("../pages/auth/Signup.jsx"));
const VerifyEmail = lazy(() => import("../pages/auth/VerifyEmail.jsx"));
const SetPassword = lazy(() => import("../pages/auth/SetPassword.jsx"));
const Login = lazy(() => import("../pages/auth/Login.jsx"));
const Mfa = lazy(() => import("../pages/auth/Mfa.jsx"));
const ForgotPassword = lazy(() => import("../pages/auth/ForgotPassword.jsx"));
const VerifyPassword = lazy(() => import("../pages/auth/VerifyPassword.jsx"));
const ResetPassword = lazy(() => import("../pages/auth/ResetPassword.jsx"));
const CustomToken = lazy(() => import("../pages/auth/CustomToken.jsx"));
const SpouseLogin = lazy(() => import("../pages/auth/SpouseLogin.jsx"));
const SpouseConfirm = lazy(() => import("../pages/onboarding/SpouseConfirm.jsx"));
const UploadDoc = lazy(() => import("../pages/onboarding/UploadDoc.jsx"));
const UploadDocs2025 = lazy(() => import("../pages/onboarding/UploadDocs2025.jsx"));
const InvestingRedirect = lazy(() => import("../pages/investing/InvestingRedirect.jsx"));
const InvestingDashboard = lazy(() => import("../pages/investing/Index.jsx"));
const InvestingUploadFiledReturn = lazy(() => import("../pages/investing/UploadFiledReturn.jsx"));
const InvestingUploadTaxDocs = lazy(() => import("../pages/investing/UploadTaxDocs.jsx"));
const InvestingUpload2026Docs = lazy(() => import("../pages/investing/Upload2026Docs.jsx"));
const InvestingQuestionnaire = lazy(() => import("../pages/investing/Questionnaire.jsx"));
const OnboardingRedirect = lazy(() => import("../pages/onboarding/OnboardingRedirect.jsx"));
import LayoutOnboarding from "../components/LayoutOnboarding.jsx";
import LayoutInvesting from "../components/LayoutInvesting.jsx";
const Questionnaire = lazy(() => import("../pages/onboarding/Questionnaire.jsx"));
const Confirm = lazy(() => import("../pages/onboarding/Confirm.jsx"));
const DeleteMyData = lazy(() => import("../pages/delete-my-data/Index.jsx"));
import LayoutAuth from "../components/LayoutAuth.jsx";
const File = lazy(() => import("../pages/File/Index.jsx"));
const Setting = lazy(() => import("../pages/setting/Index.jsx"));
import ProtectedRoute from "../components/ProtectedRoute.jsx";
import DashboardRedirect from "../components/DashboardRedirect.jsx";

export const routes = [
  {
    path: "/signup",
    layout: LayoutAuth,
    component: <Signup />,
  },
  {
    path: "/verify-email",
    layout: LayoutAuth,
    component: <VerifyEmail />,
  },
  {
    path: "/set-password",
    layout: LayoutAuth,
    component: <SetPassword />,
  },
  {
    path: "/login",
    layout: LayoutAuth,
    component: <Login />,
  },
  {
    path: "/mfa",
    layout: LayoutAuth,
    component: <Mfa />,
    // No guard - requires a pending MFA session token; the page itself
    // redirects to /login when the session is missing or invalid.
  },
  {
    path: "/forgot-password",
    layout: LayoutAuth,
    component: <ForgotPassword />,
  },
  {
    path: "/reset-password",
    layout: LayoutAuth,
    component: <ResetPassword />,
  },
  {
    path: "/verify-password",
    layout: LayoutAuth,
    component: <VerifyPassword />,
  },
  {
    path: "/custom-token",
    component: <CustomToken />,
    // No guard - handles its own token authentication
  },
  {
    path: "/spouse-login",
    component: <SpouseLogin />,
    // No guard - handles its own token authentication
  },
  {
    path: "/spouse-confirm",
    component: <SpouseConfirm />,
    guard: ProtectedRoute,
    // No LayoutOnboarding - has its own minimal layout
  },
  {
    path: "/onboarding",
    component: <OnboardingRedirect />,
    guard: ProtectedRoute,
  },
  {
    path: "/onboarding/upload",
    layout: LayoutOnboarding,
    component: (
      <DashboardRedirect requireComplete={false} currentStep={1}>
        <UploadDoc />
      </DashboardRedirect>
    ),
    guard: ProtectedRoute,
  },
  {
    path: "/onboarding/upload-2025",
    layout: LayoutOnboarding,
    component: (
      <DashboardRedirect requireComplete={false} currentStep={1}>
        <UploadDocs2025 />
      </DashboardRedirect>
    ),
    guard: ProtectedRoute,
  },
  {
    path: "/onboarding/questionnaire",
    layout: LayoutOnboarding,
    component: (
      <DashboardRedirect requireComplete={false} currentStep={2}>
        <Questionnaire />
      </DashboardRedirect>
    ),
    guard: ProtectedRoute,
  },
  {
    path: "/onboarding/confirm",
    layout: LayoutOnboarding,
    component: <Confirm />,
    guard: ProtectedRoute,
  },
  {
    path: "/investing",
    component: <InvestingRedirect />,
    guard: ProtectedRoute,
  },
  {
    path: "/investing/",
    component: <InvestingRedirect />,
    guard: ProtectedRoute,
  },
  {
    path: "/investing/upload",
    layout: LayoutInvesting,
    component: <InvestingUploadFiledReturn />,
    guard: ProtectedRoute,
  },
  {
    path: "/investing/upload-2025",
    layout: LayoutInvesting,
    component: <InvestingUploadTaxDocs />,
    guard: ProtectedRoute,
  },
  {
    path: "/investing/upload-2026",
    layout: LayoutInvesting,
    component: <InvestingUpload2026Docs />,
    guard: ProtectedRoute,
  },
  {
    path: "/investing/questionnaire",
    layout: LayoutInvesting,
    component: <InvestingQuestionnaire />,
    guard: ProtectedRoute,
  },
  {
    path: "/investing/dashboard",
    component: <InvestingDashboard />,
    guard: ProtectedRoute,
  },
  {
    path: "/investing/ask/:sessionId",
    component: <InvestingDashboard />,
    guard: ProtectedRoute,
  },
  {
    path: "/investing/plaid/oauth-return",
    component: <InvestingDashboard />,
    guard: ProtectedRoute,
  },
  {
    path: "/delete-my-data",
    layout: LayoutOnboarding,
    component: <DeleteMyData />,
    guard: ProtectedRoute,
  },
  {
    path: "/file",
    component: <File />,
    guard: ProtectedRoute,
  },
  {
    path: "/setting",
    component: <Setting />,
    guard: ProtectedRoute,
  },
];
